import "./Faqs.scss";
import React, { useState } from "react";
import { AiOutlineClose, AiOutlinePlus } from "react-icons/ai";
import faqimg from "../../assets/faqimg.png";

const faqData = [
  {
    question: "How does crypto payment processing work for my business?",
    answer:
      "Customers pay in crypto, we process and convert it instantly, and you get paid securely — no extra steps needed.",
  },
  {
    question: "Do I need to understand crypto to accept it in my store?",
    answer:
      "Not at all. Our platform handles everything for you, no crypto knowledge required.",
  },
  {
    question: "How long does it take to settle payments?",
    answer:
      "Most payments are settled in minutes, depending on the blockchain network used.",
  },
  {
    question:
      "How are crypto payments more cost-effective than traditional ones?",
    answer:
      "They come with lower fees — starting at just 0.5% — and no hidden charges.",
  },
  {
    question: "Is it safe to accept cryptocurrency payments?",
    answer:
      "Yes. We use strong security features like 2FA, whitelisting, and role-based access.",
  },
  {
    question: "Can I convert crypto to fiat instantly?",
    answer:
      "Yes, with auto-conversion, you get paid in fiat and avoid crypto volatility.",
  },
  {
    question: "Is there any customer support if I run into issues?",
    answer:
      "Absolutely. Our team offers fast, expert support whenever you need help.",
  },
];

export default function Faqs() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFaq = (index) => {
    setOpenIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <div className="faqs spacing">
      <div className="left">
        <div className="content">
          <h2 className="head1">Frequently</h2>
          <h2 className="head1"> asked questions</h2>
          <h2 className="head2">Frequently asked question</h2>
          {/* <p>Have more questions?</p> */}
          {/* <button>Contact Us</button> */}
        </div>
        <img src={faqimg} alt="error" />
      </div>
      <div className="right">
        <div className="faqslist">
          {faqData.map((faq, index) => (
            <div className="faq-item" key={index}>
              <div className="faq-question">
                <h2>{faq.question}</h2>
                <span
                  className={`faq-icon ${openIndex === index ? "rotated" : ""}`}
                  onClick={() => toggleFaq(index)}
                >
                  {openIndex === index ? (
                    <AiOutlineClose />
                  ) : (
                    <AiOutlinePlus className="plus" />
                  )}
                </span>
              </div>
              <div
                className={`faq-answer ${openIndex === index ? "open" : ""}`}
              >
                <div className="faq-answer-content">
                  <p>{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
